// Misión 07e: fragmento de assets/theme.js del live (theme 165661802731), de su comentario de inicio a su comentario de
// fin, copiado tal cual dentro de una función para no crear globales en Horizon. Lo genera tools/pages-port.mjs.
(() => {
/* start of Wrap iframes on containers */
const iframes = document.querySelectorAll(".page-text iframe");

function wrapElement(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

iframes.forEach(iframe => {
  if (iframe.classList.contains("no-wrap")) {
    return;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'iframe-container';
  wrapElement(iframe, wrapper);
});

/* end of Wrap iframes on containers */
})();
